@if ({
  products: products$ | async,
  expanded: expanded$ | async,
  }; as content) {
  <div #container class="js-container-product-comparator container-product-comparator" [ngClass]="{ expanded: content.expanded }">
    <div class="container">
      <div class="collapser">
        <button type="button" (click)="toggleComparator()">
          <span class="material-symbols-outlined icon" [ngClass]="{ expanded: content.expanded }"> keyboard_arrow_up </span>
        </button>
      </div>
      <div class="grid-items">
        @for (product of content.products; track product) {
          <div class="item item-product">
            <product-comparator-mini-card [product]="product"></product-comparator-mini-card>
          </div>
        }
        <ng-container *limitUp="DEVICE_SIZE.DESKTOP">
          @for (item of createPlaceHolder(content.products?.length || 0); track item) {
            <div class="item item-product placeholder"></div>
          }
        </ng-container>
        <div class="item item-actions">
          @if (((content.products || [])?.length || 0) > 1) {
            <a
              [routerLink]="['/products-compare']"
              [queryParams]="{ pids: getProductID(content.products || []) }"
              class="btn btn-primary btn-sm w-100"
              >
              <span class="material-symbols-outlined d-flex m-r-4"> text_compare </span>
              {{ 'productComparator.compare' | cxTranslate }} ({{ content.products?.length }})
            </a>
          }
          <button class="btn btn-primary btn-sm w-100" (click)="removeAllProducts()">
            <span class="material-symbols-outlined d-flex m-r-4"> delete </span>
            {{ 'productComparator.removeAll' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
